export default __webpack_public_path__ + "static/media/pic5.a46bcc2b.jpg";